import { createSelector } from 'reselect';

import { StringStateDictionary } from '../reducers/utils/state-manager';

type NotificationSettingsDictionary = { [notificationSettingId: number]: NotificationSetting };

export type NotificationSettingsState = {
  notificationSettingsById: NotificationSettingsDictionary;
  notificationSettingsStateByParams: StringStateDictionary;
};
type State = { notificationSettings: NotificationSettingsState };

const notificationSettingsSelector = (state: State) =>
  state.notificationSettings.notificationSettingsById;
export const notificationSettingsBySubscribedToOrgIdSelector = createSelector(
  [notificationSettingsSelector, (_state: State, subscribedToOrgId: number) => subscribedToOrgId],
  (notificationSettingsById: NotificationSettingsDictionary, subscribedToOrgId: number) =>
    Object.values(notificationSettingsById).filter(
      (ns) => ns && ns.subscribedToOrgId === subscribedToOrgId,
    ),
);

const notificationSettingsStateByParamsSelector = (state: State) =>
  state.notificationSettings.notificationSettingsStateByParams;
export const notificationSettingsStateForParamsSelector = createSelector(
  [notificationSettingsStateByParamsSelector, (_state: State, params: string) => params],
  (notificationSettingsStateByOrgId: StringStateDictionary, params: string) =>
    notificationSettingsStateByOrgId[params],
);
